module.exports = __webpack_public_path__ + "static/media/horizontal-branco.6360319a.svg";